import Vue from 'vue'
import Vuex from 'vuex'
import api from '@/api'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    companyInfo: null,
    products: [],
    news: [],
    loading: false
  },
  mutations: {
    SET_COMPANY_INFO (state, info) {
      state.companyInfo = info
    },
    SET_PRODUCTS (state, products) {
      state.products = products
    },
    SET_NEWS (state, news) {
      state.news = news
    },
    SET_LOADING (state, loading) {
      state.loading = loading
    }
  },
  actions: {
    async fetchCompanyInfo ({ commit }) {
      try {
        commit('SET_LOADING', true)
        const response = await api.getCompanyInfo()
        commit('SET_COMPANY_INFO', response.data)
      } catch (error) {
        console.error('获取公司信息失败:', error)
      } finally {
        commit('SET_LOADING', false)
      }
    },
    async fetchProducts ({ commit }) {
      try {
        commit('SET_LOADING', true)
        const response = await api.getProducts()
        commit('SET_PRODUCTS', response.data)
      } catch (error) {
        console.error('获取产品信息失败:', error)
      } finally {
        commit('SET_LOADING', false)
      }
    },
    async fetchNews ({ commit }) {
      try {
        commit('SET_LOADING', true)
        const response = await api.getNews()
        commit('SET_NEWS', response.data)
      } catch (error) {
        console.error('获取新闻信息失败:', error)
      } finally {
        commit('SET_LOADING', false)
      }
    }
  },
  getters: {
    featuredNews: state => state.news.filter(item => item.isFeatured),
    latestNews: state => state.news.slice(0, 5)
  }
})
